import * as React from 'react'
import { Popover } from '@manychat/manyui'

import { FieldList } from 'common/fields/linking/components/FieldList'
import { IVariableSuggestionData } from 'components/MCTextEditor/types'
import { SliceComponent } from 'components/RichTextEditor/types'

import { exportVariable } from '../adapter'

const popoverStyle = { width: 240 }

const VariableInput: SliceComponent = ({ processor, input, insert, slice }) => {
  const [isPopoverOpen, setIsPopoverOpen] = React.useState(false)
  const sliceRef = React.useRef(null)
  const content = processor.getText().slice(slice.range.start, slice.range.end)
  const { fields, query } = slice.data as IVariableSuggestionData

  React.useEffect(() => {
    setIsPopoverOpen(true)
  }, [])

  const handlePopoverRequestClose = () => {
    setIsPopoverOpen(false)
  }

  const handleSelect = (value: string) => {
    processor.select(slice.range.start)
    processor.delete(slice.range.start, slice.range.length)
    insert(exportVariable({ id: value }))
  }

  return (
    <React.Fragment>
      <span ref={sliceRef}>{content}</span>
      <Popover
        anchor={sliceRef.current}
        anchorOrigin="bottom left"
        popoverOrigin="top left"
        open={isPopoverOpen}
        onRequestClose={handlePopoverRequestClose}
        style={popoverStyle}
      >
        <FieldList fields={fields} onSelect={handleSelect} query={query} target={input} />
      </Popover>
    </React.Fragment>
  )
}

export default VariableInput
